/* Shop nav label.
 * "My Personal Rhúne Selection" once body proportion, usual size, and fit
 * preference are saved. Optional questions do not have to be filled.
 * Otherwise the link stays "Size & Fit Guide".
 */
(function () {
  var NAV_SELECTOR = "a[data-contourlab-fmf-nav]";
  var SHOP_ID = "304480c8-8a0e-4b44-80bc-3c61ce742f14";
  var STATUS_URL = "https://api.contourlab.io/survey-status";
  var SHOPPER_COOKIE = "contourlab_shopper_id";
  var CORE_PREFIX = "contourlab_rhune_core_";
  var collectionHref = null;

  function shopperId() {
    try {
      var match = document.cookie.match(
        new RegExp("(?:^|; )" + SHOPPER_COOKIE + "=([^;]+)")
      );
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function toHref(path) {
    if (!path || typeof path !== "string") return null;
    try {
      return new URL(path, window.location.origin).href;
    } catch (e) {
      return null;
    }
  }

  function remember(id, complete) {
    try {
      localStorage.setItem(CORE_PREFIX + id, complete ? "1" : "0");
    } catch (e) {}
  }

  function apply(complete, href) {
    document.documentElement.classList.toggle("contourlab-fmf-complete", complete);
    collectionHref = complete ? href : null;
    if (!collectionHref) return;
    document.querySelectorAll(NAV_SELECTOR).forEach(function (anchor) {
      if (anchor.href !== collectionHref) anchor.href = collectionHref;
      if (anchor.dataset.contourlabFmfLabelBound === "1") return;
      anchor.dataset.contourlabFmfLabelBound = "1";
      new MutationObserver(function () {
        if (collectionHref && anchor.href !== collectionHref) {
          anchor.href = collectionHref;
        }
      }).observe(anchor, { attributes: true, attributeFilter: ["href"] });
    });
  }

  function isComplete(data) {
    if (!data) return false;
    if (data.core_fields_complete === true) return true;
    return Number(data.fit_survey_progress) === 100;
  }

  document.addEventListener(
    "click",
    function (event) {
      if (!collectionHref) return;
      var anchor = event.target && event.target.closest
        ? event.target.closest(NAV_SELECTOR)
        : null;
      if (!anchor) return;
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = collectionHref;
    },
    true
  );

  var id = shopperId();
  if (!id) return;

  fetch(
    STATUS_URL +
      "?shopper_id=" +
      encodeURIComponent(id) +
      "&shop_id=" +
      encodeURIComponent(SHOP_ID),
    { credentials: "omit" }
  )
    .then(function (response) {
      if (!response.ok) throw new Error("status " + response.status);
      return response.json();
    })
    .then(function (data) {
      var complete = isComplete(data);
      remember(id, complete);
      apply(complete, toHref(data && data.shopify_collection_path));
    })
    .catch(function () {});
})();
